// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import StoneTypes from './StoneTypes';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(StoneTypes);
